(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-members"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.querySelector('#team-members-{{ section.id }}');
  if (!section) return;

  const images = Array.from(section.querySelectorAll('.team-member .team-image'));
  if (!images.length) return;

  function handleScroll() {
    const windowHeight = window.innerHeight;

    images.forEach(img => {
      const rect = img.getBoundingClientRect();
      const imgCenter = rect.top + rect.height / 2;
      const viewportCenter = windowHeight / 2;

      const distance = Math.abs(viewportCenter - imgCenter);
      const progress = Math.min(distance / (windowHeight / 2), 1);

      // Increased growth and zoom effect
      const scale = 1.2 + 0.5 * (1 - progress); // max ~1.7x at center
      const translateY = -20 * (1 - progress);   // slight upward movement for zoom feel
      img.style.transform = `scale(${scale}) translateY(${translateY}px)`;
    });
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleScroll);
  handleScroll();
})();

  } catch(e) { console.error(e); }
})();
})();
